import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getBackendURL } from '../../utils/backendURL';

export default function OrganizationAccessNotice({ children }) {
  const [blocked, setBlocked] = useState(false);
  useEffect(() => {
    const check = () => {
      if (!localStorage.getItem('token')) { setBlocked(false); return; }
      axios.get(`${getBackendURL()}/api/team/access`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      }).then(({ data }) => setBlocked(!data.allowed)).catch(() => {});
    };
    const interceptor = axios.interceptors.response.use(response => response, error => {
      if (error.response?.data?.detail?.code === 'organization_seat_suspended') setBlocked(true);
      return Promise.reject(error);
    });
    check(); const timer = setInterval(check, 15000);
    return () => { clearInterval(timer); axios.interceptors.response.eject(interceptor); };
  }, []);
  if (!blocked || window.location.pathname.startsWith('/ops')) return children;
  return <div role="alert" className="fixed inset-0 z-[100] bg-white flex items-center justify-center p-8">
    <div className="max-w-lg space-y-4"><h1 className="text-2xl font-semibold">Organization access suspended</h1>
      <p>Your organization has reached its member limit. Contact the owner to reactivate your seat. Your data has been preserved.</p>
      <button className="px-4 py-2 border rounded" onClick={() => window.location.reload()}>Check access again</button>
      <button className="px-4 py-2 border rounded ml-3" onClick={() => {
        localStorage.removeItem('token'); window.location.href = '/';
      }}>Sign out</button>
    </div>
  </div>;
}
